import React from "react";
// import ResumeImage from "../../Images/resume1.png";
import ResumePdf from "../../Images/resume1.pdf";

import "./ResumeCard.css";

function ResumeCard() {
  return (
    <>
      <div>
        <div className="resume-wrapper">
          {/* <img className="resume-img" src={ResumeImage} alt="resume" /> */}
          <embed
            className="resume-img"
            src={ResumePdf}
            width="500px"
            height="1150px"
            type="application/pdf"
          />
        </div>
      </div>
    </>
  );
}

export default ResumeCard;
